import { TLang, ILangMethods } from "./interface";
import { langEntity } from "./entity";

export default <ILangMethods> {

	setLang(v: TLang) {
		langEntity.langLocale = langEntity.lang = langEntity.langState = v;
	},

	init() {

		if (localStorage.getItem('lang') === null) {
			localStorage.setItem('lang', 'ru')
		}

		if (langEntity.langState != langEntity.lang) {
			langEntity.langState = langEntity.langLocale = langEntity.lang
		}

		let langUpdate: boolean = false;

		window.addEventListener('storage', (e) => {
			if (e.key === 'lang' && e.newValue != langEntity.langState) langUpdate = true;

			if (langUpdate) {
				langEntity.langLocale = langEntity.lang
			}
		});
	}

}